"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.grabCursor = exports.endWithDrop = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var DragAround_1 = __importDefault(require("./DragAround"));
function Draggable(_a) {
    var children = _a.children, type = _a.type, item = _a.item, options = _a.options, previewOptions = _a.previewOptions, draggingChange = _a.draggingChange, end = _a.end, canDrag = _a.canDrag, isDragging = _a.isDragging, drop = _a.drop, css = _a.css, props = __rest(_a, ["children", "type", "item", "options", "previewOptions", "draggingChange", "end", "canDrag", "isDragging", "drop", "css"]);
    var _b = (0, react_dnd_1.useDrag)({
        type: type,
        item: item,
        options: options,
        previewOptions: previewOptions,
        end: endWithDrop(end, drop),
        canDrag: canDrag,
        isDragging: isDragging,
        collect: function (monitor) { return ({ draggable: monitor.canDrag(), dragging: monitor.isDragging() }); }
    }), _c = _b[0], draggable = _c.draggable, dragging = _c.dragging, ref = _b[1], preview = _b[2];
    (0, react_2.useEffect)(function () {
        preview((0, react_dnd_html5_backend_1.getEmptyImage)());
    }, []);
    (0, react_2.useEffect)(function () {
        if (draggingChange) {
            draggingChange(dragging);
        }
    }, [dragging, draggingChange]);
    return ((0, jsx_runtime_1.jsx)(DragAround_1.default, __assign({ ref: ref, dragging: dragging, css: [css, draggable && exports.grabCursor] }, props, { children: children })));
}
exports.default = Draggable;
function endWithDrop(end, drop) {
    return function (draggedItem, monitor) {
        if (end) {
            end(draggedItem, monitor);
        }
        if (drop && monitor.didDrop()) {
            var dropResult = monitor.getDropResult();
            if (dropResult) {
                drop(omitDropEffect(dropResult));
            }
        }
    };
}
exports.endWithDrop = endWithDrop;
function omitDropEffect(dropResult) {
    var dropEffect = dropResult.dropEffect, result = __rest(dropResult, ["dropEffect"]);
    return result;
}
exports.grabCursor = (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: grab;\n"], ["\n  cursor: grab;\n"])));
var templateObject_1;
